module.exports = __webpack_public_path__ + "static/img/openaccess_socialmedia_2.cd73d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/openaccess_socialmedia_2.png
// module id = zf0S
// module chunks = 6